module.exports = __webpack_public_path__ + "static/cc-1-d435d3063b469d5fcac653d2cce382e2.jpg";